import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

export const fetchListCLS = createAsyncThunk("cls/fetchListCLS", async (_, { rejectWithValue }) => {
  try {
    const res = await api.get("/medeco.cls.service", {
      params: { size: 100, order: "id asc" },
    });
    return res.data?.content || [];
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

const clsSlice = createSlice({
  name: "cls",
  initialState: {
    listCLS: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchListCLS.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchListCLS.fulfilled, (state, action) => {
        state.listCLS = action.payload;
        state.loading = false;
      })
      .addCase(fetchListCLS.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default clsSlice.reducer;
